/**
 * Created by richard on 7/14/14.
 */
var flagModel = angular.module('flagModel', ['schoolModel']);
flagModel.factory('FlagModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory, AbstractModelService){
    var FlagModel = function(){
        this.endpoint = "/Flag";
        this.primaryKey = "recordID";
    }
    FlagModel.prototype = new SchoolModelFactory();
    FlagModel.prototype.parent = SchoolModelFactory.prototype;
    
    FlagModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        var flag = {schoolID: schoolID, Amount: '', Field: '', IsCaution: '', Operator: '', deleted:''};
        return flag;
    }
    
    return FlagModel;
});


flagModel.service('FlagModelService', function(FlagModelFactory){
    var flagModel = new FlagModelFactory();
    return flagModel;
});


